module.exports = __webpack_public_path__ + "app/principal/do-2zJnD6Tn.html";